import React, { useState } from 'react'
import { Button, Col, Form, Icon, Input, Avatar, Row, Upload, Modal ,Typography } from 'antd'
import { ButtonEx } from '../../styles/button.style'
import { useDeepEffect } from '../../utils/hooks'
import _, { isNull } from 'lodash'
import { beforeUpload, compressFile, getBase64 } from '../../utils/services'
import axios from 'axios'
const { Text } = Typography;

const Account = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form
  const [imageUrl, setImageUrl] = useState('')

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        email: formData.email
      })
      setImageUrl(formData.avatar)
    }

    return () => {
      form.resetFields()
      setImageUrl('')
    }
  }, [formData])

  async function updateUserAccount(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.put(
        process.env.REACT_APP_API_ENDPOINT + `/userAdmin/updateUserAccount`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  async function uploadImage(file) {
    try {
      const formData = new FormData()
      formData.append('image', await compressFile(file))
      const token = localStorage.getItem('user-token')
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/userAdmin/image`,
        formData,
        {
          headers: {
            'content-type': 'multipart/form-data',
            Authorization: !_.isNull(token) ? token : ''
          }
        }
      )
      return res.data
    } catch (err) {
      return null
    }
  }

  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          email: values.email
        }

        if (values.image) {
          const img = await uploadImage(values.image.file)
          data.avatar = img.url
        } else {
          data.avatar = formData.avatar
        }

        if (values.password) {
          data.password = values.password
        }

        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        await updateUserAccount(data)
        onOk()
        setImageUrl('')
      }
    })
  }
  return (
    <Modal
      title="Account"
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form onSubmit={onSubmit}>
        <Row type="flex" justify="center">
          <Col>
            <Form.Item>
              {getFieldDecorator(`image`, {
                rules: [
                  {
                    required: isNull(formData),
                    message: 'เลือกรูปภาพ'
                  }
                ]
              })(
                <Upload
                  name="avatar"
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={(file) => beforeUpload(file)}
                  onChange={handleChange}>
                  {imageUrl ? (
                    <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              )}
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="ชื่อ (User name)">
          {getFieldDecorator(`name`, {
            rules: [
              { required: true, message: 'กรุณากรอก' },
            ]
          })(
            <Input
              name="name"
              placeholder="name"
            />
          )}
        </Form.Item>
        <Form.Item label="อีเมล (Email)">
          {getFieldDecorator(`email`, {
            rules: [
              { required: true, message: 'กรุณากรอก' },
              {
                type: 'email',
                message: 'กรอกรูปแบบอีเมล'
              }
            ]
          })(
            <Input
              name="email"
              placeholder="email"
            />
          )}
        </Form.Item>
        <Form.Item label="รหัสผ่าน (Password)">
          {getFieldDecorator(`password`, {
            rules: [
              {
                min: 6,
                message: 'กรอกอย่างน้อย 6 ตัวอักษร'
              }
            ]
          })(
            <Input.Password
              placeholder="อย่างน้อย 6 ตัวอักษร"
              type="password"
              autoComplete="off"
            />
          )}
        </Form.Item>
        <Row type="flex" gutter={8} justify="center">
          <Col>
            <Text type="danger">*กรณีแก้ไขข้อมูลคุณจำเป็นต้องเข้าสู่ระบบใหม่อีกครั้ง</Text>
          </Col>
        </Row>
        <Row type="flex" gutter={8} justify="center">
          <br></br>
        </Row>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedAccount = Form.create({ name: 'Account' })(Account)
export default WrappedAccount